import {Button} from '@guestapp/ui';
import {closeSession, hasSession} from 'components/sessions/utils';
import {useTranslation} from 'react-i18next';
import {LogOut} from 'lucide-react';
import {useReservation} from 'context/reservation';

function EndSessionButton() {
  const {t} = useTranslation();
  const {reservationId} = useReservation();

  if (!hasSession(reservationId)) {
    return null;
  }
  return (
    <Button
      customIcon={<LogOut size={18} />}
      iconProps={{position: 'left'}}
      floating
      onClick={() => closeSession(reservationId)}
      label={t('exit')}
      className="end-session-button"
    />
  );
}

export {EndSessionButton};
